import { ACCESS_TOKEN, HOME_PAGE_ATTRIBUTE, homePathByByAttributeMap, UserHomePaths } from '@constants/global';

/**
 * Returns the user's home URL based on the provided attributes.
 *
 * @param {string[]} attributes - The user's attributes.
 * @param {string} accessToken - The user's access token.
 *
 * @returns {string} The user's home URL.
 */
export const getUserHomeUrl = (attributes: string[], accessToken: string) =>
  attributes.reduce((acc, attribute) => {
    const homePath = homePathByByAttributeMap.get(attribute);
    const [group] = attribute.split(':');
    if (homePath && group === HOME_PAGE_ATTRIBUTE) {
      if (homePath !== UserHomePaths.Cii) {
        return `${process.env.NEXT_PUBLIC_LINERS_UI}${homePath}?${ACCESS_TOKEN}=${accessToken}`;
      }
      return window.location.origin;
    }
    return acc;
  }, window.location.origin);
